import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import ThesisProjects from '@/pages/ThesisProjects';
import ThesisWorkspace from '@/pages/ThesisWorkspace';
import ThesisLogin from '@/pages/ThesisLogin';
import ThesisForgotPassword from '@/pages/ThesisForgotPassword';
import ThesisResetPassword from '@/pages/ThesisResetPassword';
import ThesisRegister from '@/pages/ThesisRegister';
import BillingPage from './pages/BillingPage';
import LegalPage from '@/pages/LegalPage';
import BrandPage from '@/pages/BrandPage';
import AboutPage from '@/pages/AboutPage';
import AccountDataPage from '@/pages/AccountDataPage';
import ProfilePage from '@/pages/ProfilePage';
import WelcomePage from '@/pages/WelcomePage';
import GuidePage from '@/pages/GuidePage';
import GuidesIndexPage from '@/pages/GuidesIndexPage';
import AdminPromoPage from '@/pages/AdminPromoPage';
import AdminInboxPage from '@/pages/AdminInboxPage';
import ContactPage from '@/pages/ContactPage';
import JournalAuthorsPage from '@/pages/JournalAuthorsPage';
import ChatWidget from '@/components/ChatWidget';
import { DISS_UI, DISS_QUICKSTART, DISS_SECTIONS } from '@/content/guideDissertation';
import CookieConsent from '@/components/CookieConsent';
import ScreenRecorder from '@/components/ScreenRecorder';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/components/ThemeProvider';
import ErrorBoundary from '@/components/ErrorBoundary';
import { setupAxios } from '@/api/axiosSetup';

setupAxios();

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <div className="App min-h-screen bg-background text-foreground">
          <BrowserRouter>
            <ErrorBoundary>
              <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/thesis/login" element={<ThesisLogin />} />
              <Route path="/thesis/forgot-password" element={<ThesisForgotPassword />} />
              <Route path="/thesis/reset-password" element={<ThesisResetPassword />} />
              <Route path="/thesis/register" element={<ThesisRegister />} />
              {/* Also expose short aliases so email links (which use APP_URL/reset-password) work */}
              <Route path="/forgot-password" element={<ThesisForgotPassword />} />
              <Route path="/reset-password" element={<ThesisResetPassword />} />
              <Route path="/author/register" element={<ThesisRegister />} />
              <Route path="/author/login" element={<ThesisLogin />} />
              <Route path="/thesis" element={<ThesisProjects />} />
              <Route path="/thesis/billing" element={<BillingPage />} />
              <Route path="/thesis/profile" element={<ProfilePage />} />
              <Route path="/thesis/admin/promos" element={<AdminPromoPage />} />
              <Route path="/thesis/admin/inbox" element={<AdminInboxPage />} />
              <Route path="/thesis/welcome" element={<WelcomePage />} />
              <Route path="/thesis/:projectId" element={<ThesisWorkspace />} />
              <Route path="/legal/terms" element={<LegalPage kind="terms" />} />
              <Route path="/legal/privacy" element={<LegalPage kind="privacy" />} />
              <Route path="/legal/ruo" element={<LegalPage kind="ruo" />} />
              <Route path="/legal/ai-transparency" element={<LegalPage kind="ai" />} />
              <Route path="/legal/cookies" element={<LegalPage kind="cookies" />} />
              <Route path="/legal/ai-act" element={<LegalPage kind="aiact" />} />
              <Route path="/legal/dpa" element={<LegalPage kind="dpa" />} />
              <Route path="/legal/subprocessors" element={<LegalPage kind="subprocessors" />} />
              <Route path="/legal/billing" element={<LegalPage kind="billing" />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/guide" element={<GuidePage />} />
              <Route path="/guides" element={<GuidesIndexPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/journal-authors" element={<JournalAuthorsPage />} />
              <Route path="/guide/dissertation" element={
                <GuidePage ui={DISS_UI} quickstart={DISS_QUICKSTART} sections={DISS_SECTIONS}
                  path="/guide/dissertation"
                  sibling={{ to: '/guide', label: { en: 'Article guide', bg: 'Ръководство за статия' } }} />
              } />
              <Route path="/brand" element={<BrandPage />} />
              <Route path="/thesis/account" element={<AccountDataPage />} />
              <Route path="*" element={<Navigate to="/thesis" replace />} />
              </Routes>
              <CookieConsent />
              <ChatWidget />
              <ScreenRecorder />
            </ErrorBoundary>
          </BrowserRouter>
          <Toaster />
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
